import React, { FunctionComponent, useContext, useEffect } from 'react';
import { EventModel } from 'features/events/EventModel';
import { PageAnimationOpacity } from 'components/LayoutAnimations/PageAnimationOpacity';
import { EventWrapper } from 'features/events/EventWrapper';
import { EventCreatorContent } from 'features/events/EventCreator/EventCreatorContent';
import { useDispatch } from 'react-redux';
import {
  setNativeEventStarted,
  setNativeEventStopped
} from 'features/events/eventsSlice';
import { useIsEventLive } from 'features/events/eventHooks';
import { useOnceEffect } from 'hooks/useOnceEffect';
import { UserAgentContext } from 'features/user-agent/userAgent';
import { useAppSelector } from 'hooks/redux';
import { Mixpanel } from 'utilities/mixpanel';

interface EventEmbedProps {
  event: EventModel | null;
}

export const EventCreator: FunctionComponent<EventEmbedProps> = ({ event }) => {
  const dispatch = useDispatch();
  const isLive = useIsEventLive(event);
  const { isDACreatorAppVersion } = useContext(UserAgentContext);
  const isSingleDAView = isDACreatorAppVersion(
    `${process.env.REACT_APP_DA_SINGLE_VIEW_MIN_VERSION}`
  );
  const channelDetails = useAppSelector(
    (state) => state.channel.channelDetails
  );

  useEffect(
    function resetNativeAudioState() {
      if (isLive) {
        dispatch(setNativeEventStarted(false));
        dispatch(setNativeEventStopped(false));
      }
    },
    [isLive, dispatch]
  );

  useOnceEffect(function mixpanelPageViewForDA() {
    if (channelDetails && channelDetails?.ownerId) {
      Mixpanel.identify(channelDetails.ownerId);
      Mixpanel.track('Page Viewed');
    }
  }, isSingleDAView && channelDetails);

  return (
    <PageAnimationOpacity>
      <EventWrapper event={event}>
        <EventCreatorContent event={event} />
      </EventWrapper>
    </PageAnimationOpacity>
  );
};
